import { useState, useEffect, useCallback } from 'react';
import { t, getLocale, setLocale, Locale } from './index';

export function useTranslations(namespace?: string) {
  const [, setUpdate] = useState(0);

  useEffect(() => {
    const handleLocaleChange = () => {
      setUpdate((prev) => prev + 1);
    };

    window.addEventListener('locale-change', handleLocaleChange);
    return () => {
      window.removeEventListener('locale-change', handleLocaleChange);
    };
  }, []);

  const translate = useCallback(
    (key: string, params?: Record<string, string | number>) => {
      const fullKey = namespace ? `${namespace}.${key}` : key;
      return t(fullKey, params);
    },
    [namespace]
  );

  return {
    t: translate,
    locale: getLocale(),
    setLocale,
  };
}

export function useLocale() {
  const [locale, setLocaleState] = useState<Locale>(getLocale());

  useEffect(() => {
    const handleLocaleChange = (e: Event) => {
      const customEvent = e as CustomEvent<Locale>;
      setLocaleState(customEvent.detail);
    };

    window.addEventListener('locale-change', handleLocaleChange);
    return () => {
      window.removeEventListener('locale-change', handleLocaleChange);
    };
  }, []);

  const toggleLocale = useCallback(() => {
    const newLocale = locale === 'en' ? 'ko' : 'en';
    setLocale(newLocale);
  }, [locale]);

  return {
    locale,
    setLocale,
    toggleLocale,
  };
}
